var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBarChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 140,
    viewBox: "0 0 358 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_6885",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 359,
    height: 140
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00268555 5C0.00268555 2.23857 2.24126 0 5.00269 0H353.003C355.764 0 358.003 2.23858 358.003 5V135C358.003 137.761 355.764 140 353.003 140H5.00269C2.24127 140 0.00268555 137.761 0.00268555 135V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_6885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.043 64C253.043 61.7909 254.834 60 257.043 60H278.124C280.333 60 282.124 61.7909 282.124 64V141H253.043V64Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.152 90C292.152 87.7909 293.943 86 296.152 86H317.234C319.443 86 321.234 87.7909 321.234 90V141H292.152V90Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.937 103C214.937 100.791 216.727 99 218.937 99H240.018C242.227 99 244.018 100.791 244.018 103V141H214.937V103Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.261 52C331.261 49.7909 333.052 48 335.261 48H356.343C358.552 48 360.343 49.7909 360.343 52V141H331.261V52Z",
    fill: "#FFC000"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBarChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bar-chart.880d51f9dcedfe21dab26e8c22520f75.svg";